// 凑单页
const Config = {
  // 凑单页
  'Joinmore.search_title': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'search',
    },
    d: {
      type: 'variable',
      func: function () {
        return '1';
      },
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        return `search_term=${encodeURIComponent(traceData.tag || '')}`;
      },
    },
  },
  'Joinmore.filter': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'sort',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.id;
      },
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        return `tag=${encodeURIComponent(traceData.tag || '')}`;
      },
    },
  },
  'Joinmore.filter_other': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'filter',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return '1';
      },
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        return `tag=${encodeURIComponent(traceData.tag)}`;
      },
    },
  },
  'Joinmore.filterBar.back': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'prev',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Joinmore.to_cart': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'cart',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function ({ u }) {
        return `u=${encodeURIComponent(u)}`;
      },
    },
  },
  'Joinmore.checkgift': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'checkgift',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Joinmore.search_list': {
    operation: ['VISIBLE'],
    getParse_rec_list: {
      func: function (item = {}, visibleData, args) {
        const {
          pageName,
          traceObj: { filterText, searchText, tradeUrlPrefix },
        } = args;
        const res = item.item.reduce((result, subItem) => {
          const { pid, action, gid } = subItem.goodsData.data.goodsInfo;
          const { under800s = [], beforeTitle = [], underPrice = [] } = subItem.goodsData.data.newLabels;
          const label = [...under800s, ...beforeTitle, ...underPrice].reduce((sum, { text }) => {
            let res = sum;
            if (text === undefined) {
              return res;
            }
            if (res) {
              res += '_';
            }
            res += text;
            return res;
          }, '');
          const u = `${tradeUrlPrefix}mfbs/mstd/product?commodityId=${pid}${gid ? `&goodsId=${gid}` : ''}`;
          const res = {
            type: 'rec_list',
            item: subItem,
            isViewable: item.isViewable,
            key: subItem.index,
            page: pageName,
            b: pageName,
            c: 'product',
            // area: 'search_list',
            d: subItem.index + 1,
            iid: `next=product.${pid}`,
            // iid: `type1=${0}&type2=${0}&product_id=${pid}&label=${encodeURIComponent(
            //   label,
            // )}&next=product.${pid}&tags=${encodeURIComponent(filterText)}&search_term=${encodeURIComponent(
            //   searchText,
            // )}&u=${encodeURIComponent(u)}`,
            scmv2: action.scm,
          };
          const res2 = {
            type: 'rec_list_addcart',
            item: subItem,
            isViewable: item.isViewable,
            key: subItem.index,
            page: pageName,
            b: pageName,
            c: 'addcart',
            // area: 'search_list',
            d: subItem.index + 1,
            // iid: `next=product.${pid}`,
            // iid: `type1=${0}&type2=${0}&product_id=${pid}&label=${encodeURIComponent(
            //   label,
            // )}&next=product.${pid}&tags=${encodeURIComponent(filterText)}&search_term=${encodeURIComponent(
            //   searchText,
            // )}&u=${encodeURIComponent(u)}`,
            scmv2: action.scm,
          };
          result.push(res);
          result.push(res2);
          return result;
        }, []);

        return res;
      },
    },
  },
  'Joinmore.search_list.touch': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'search_list',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function ({ item, filterText, searchText, u }) {
        const { under800s = [], beforeTitle = [], underPrice = [] } = item.newLabels;
        const { pid } = item.goodsInfo;
        const label = [].concat(under800s, beforeTitle, underPrice).reduce((sum, item = {}) => {
          const { text } = item;
          let res = sum;
          if (text === undefined) {
            return res;
          }
          if (res) {
            res += '_';
          }
          res += text;
          return res;
        }, '');
        return `type1=${0}&type2=${0}&product_id=${pid}&label=${encodeURIComponent(
          label,
        )}&next=product.${pid}&tags=${encodeURIComponent(filterText)}&search_term=${encodeURIComponent(
          searchText,
        )}&u=${encodeURIComponent(u)}`;
      },
    },
  },
  'Joinmore.search': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'search',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        return 'search_term=' + encodeURIComponent(traceData.search_term);
      },
    },
  },
  'Joinmore.search.button': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'search',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        return 'search_term=' + encodeURIComponent(traceData.search_term);
      },
    },
  },
  'Joinmore.addcart': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'addcart',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
    // iid: {
    //   type: 'variable',
    //   func: function (traceData) {
    //     return `product_id=${traceData.product_id}`;
    //   },
    // },
  },
  'Joinmore.select_addcart_confirm': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'done_filter',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        let res = '';
        if (traceData.payway) {
          res += `&payway=${encodeURIComponent(traceData.payway)}`;
        }
        if (traceData.skus) {
          res += `&skus=${encodeURIComponent(JSON.stringify(traceData.skus))}`;
        }
        return res;
      },
    },
  },
  'Joinmore.reset': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'reset_filter',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Joinmore.fliter_confirm': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'done_filter',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    // iid: {
    //   type: 'variable',
    //   func: function (traceData) {
    //     return `tags=${traceData.tags}`;
    //   },
    // },
  },
  'Joinmore.topFloor': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'gather_info',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Joinmore.gift_cote': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'gift_cote',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Joinmore.close_gift_popup': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'close_gift_popup',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Joinmore.giftList': {
    operation: ['VISIBLE'],
    getParse_rec_list: {
      func: function (data = {}, visibleData, args) {
        const {
          pageName,
          traceObj: { tradeUrlPrefix, activityType, tag },
        } = args;
        const item = data.item;
        const section = data.section;
        if (item.type !== 'item') {
          // 过滤掉 section header footer。 因为数据结构不相同
          return [];
        } else {
          const res = [];
          const { ssuId, itemId, index, sendType } = item;
          const key = (section.index + 1) * 10000 + index + 1;
          const u = `${tradeUrlPrefix}mfbs/mstd/product?commodityId=${itemId}${ssuId ? `&goodsId=${ssuId}` : ''}`;
          const commonResItem = {
            type: 'rec_list',
            item: item,
            isViewable: true,
            key,
            page: pageName,
            b: pageName,
            d: key,
            iid: `u=${encodeURIComponent(u)}&product_id=${ssuId}&next=product.${ssuId}&tag=${encodeURIComponent(
              tag,
            )}&child_activity_id=${activityType + '_' + sendType}`,
          };
          let c;
          if (sendType === 'one') {
            c = 'gift_multi_1';
          } else if (sendType === 'all') {
            c = 'gift_multi_full';
          } else {
            c = 'gift_multi_1';
          }
          res.push({
            ...commonResItem,
            c,
          });
          // if (ifLevel) {
          //   res.push({
          //     ...commonResItem,
          //     c: 'circlegift',
          //   });
          // }
          return res;
        }
      },
    },
  },
};

export default Config;
